import { Container, Row, Col, Text } from '@qonsoll/react-design'
import { CalculatorSimpleView } from '../../../Calculator/components'
import { useGetCustomerProfileCalculator } from '../../hooks'
import PropTypes from 'prop-types'
import { Spinner } from 'components'
import { useTranslations } from 'contexts/Translation'

export default function CustomerProfileCalculator(props) {
  const { customerProfile } = props

  // [ADDITIONAL_HOOKS]
  const [calculator, loading] = useGetCustomerProfileCalculator(customerProfile)
  const { t } = useTranslations()

  return (
    <Container>
      <Row noGutters>
        <Col>
          {loading ? (
            <Spinner flex={1} />
          ) : calculator ? (
            <CalculatorSimpleView {...props} calculator={calculator} />
          ) : (
            <Text type="secondary" variant="overline">
              {t('No calculators have been added yet')}
            </Text>
          )}
        </Col>
      </Row>
    </Container>
  )
}

CustomerProfileCalculator.propTypes = {
  customerProfile: PropTypes.object.isRequired
}
